import React from 'react';
import { render, hydrateRoot } from 'react-dom/client';
import { Router, Route } from 'react-router-dom';
import createBrowserHistory from './customHistory/createBrowserHistory';
import { loadableReady } from '@loadable/component';
import $ from 'jquery';
import './globals';
// import _ from 'lodash'

//appDesktopTablet
import loadable from '@loadable/component';
const DesktopApp = loadable(
  () => import(/* webpackChunkName: "desktop" */ '../client/components/Containers/Desktop/DesktopApp/DesktopApp')
);
const initialState = window.__INITIAL_STATE__;

var historyObject = createBrowserHistory();

class wrapperComponent extends React.Component {
  render() {
    return <DesktopApp initialState={JSON.parse(JSON.stringify(initialState))} {...this.props} />;
  }
}

$(document).ready(function () {
  if ('scrollRestoration' in history) {
    // Back off, browser, I got this...
    history.scrollRestoration = 'manual';
  }
  window.addEventListener('beforeunload', function (event) {
    if ('scrollRestoration' in history) {
      // OK, browser, take it...
      history.scrollRestoration = 'auto';
    }
  });

  loadableReady(() => {
    hydrateRoot(
      document.getElementById('root'),
      <Router history={historyObject}>
        <Route path='*' component={wrapperComponent} />
      </Router>
    );
    if (String(window.location).indexOf('local') == -1) window.__INITIAL_STATE__ = {};
  });
});
